import { PageLayout } from '@app/pages/layout/PageLayout'
import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { useSearch } from 'wouter'
import { KnowledgeHubModule } from '@schema/knowledgeHubModule'
import { LeftSidebar } from '@app/components/layout/LeftSidebar'
import { KnowledgeHubModuleSidebar } from './KnowledgeHubModuleSidebar'
import { KnowledgeHubModuleContent } from './KnowledgeHubModuleContent'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { TextLink } from '@app/components/core/link/TextLink'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'

export type KnowledgeHubItemPageProps = {
  itemId: string
}

export const KnowledgeHubModulePage = ({
  itemId,
}: KnowledgeHubItemPageProps) => {
  const t = useTranslations().app.knowledgeHubPage
  const knowledgeHubModuleQuery = useQuery('view-knowledge-hub-module', {
    id: itemId,
  })
  const knowledgeHubModuleItem: KnowledgeHubModule | undefined =
    knowledgeHubModuleQuery.data
  const search = useSearch()
  const itemSlug = useMemo(
    () =>
      new URLSearchParams(search).get('slug') ||
      knowledgeHubModuleItem?.sections?.[0]?.knowledgeHubItems?.[0]?.slug,
    [search, knowledgeHubModuleItem],
  )

  if (knowledgeHubModuleQuery.loading || !knowledgeHubModuleItem) {
    return <PageLayout gap="2rem">{t.loading}</PageLayout>
  }

  return (
    <>
      <PageLayout gap="0rem">
        <LeftSidebar>
          <LeftSidebar.Sidebar collapsedButtonLabel={t.menu}>
            <KnowledgeHubModuleSidebar
              sections={knowledgeHubModuleItem.sections}
              activeSlug={itemSlug}
            />
          </LeftSidebar.Sidebar>
          <div>
            <TextLink to={pages.knowledgeHub}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Back
            </TextLink>
            <KnowledgeHubModuleContent id={itemSlug || ''} />
          </div>
        </LeftSidebar>
      </PageLayout>
    </>
  )
}
